import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink, FiArrowRight } = FiIcons;

const FeaturedProducts = () => {
  const products = [
    {
      title: 'WatchSafe',
      description: 'Parental screen-time and YouTube filtering, built for parents who want a single-purpose app.',
      url: 'https://watchsafe.app',
      icon: 'https://i.imgur.com/Nl4cAr5.png'
    },
    {
      title: 'KeepsakeVault',
      description: 'Memory and keepsake storage for the people and moments worth keeping.',
      url: 'https://keepsakevault.app',
      icon: 'https://i.imgur.com/T0V4TJZ.png'
    },
    {
      title: 'RouteCaster',
      description: 'Advanced route planning and navigation, built for real-world trip complexity.',
      url: 'https://routecaster.app',
      icon: 'https://i.imgur.com/Lc6WQQS.png'
    },
    {
      title: 'OrganizeMe',
      description: 'AI-powered email and task triage that integrates with Gmail, Outlook, and any SMTP inbox.',
      url: 'https://organizeMe.click',
      icon: 'https://i.imgur.com/r8MzVf3.png'
    },
    {
      title: 'HomeschoolSD.org',
      description: 'A homeschool community site for South Dakota families.',
      url: 'https://homeschoolsd.org',
      icon: 'https://i.imgur.com/5NyAhOy.png'
    },
    {
      title: 'ChildThrive.org',
      description: "Preserves foster children's history across placements and providers.",
      url: 'https://childthrive.org',
      icon: 'https://i.imgur.com/ywsgdFy.png'
    }
  ];

  return (
    <section className="py-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-end mb-16">
          <div>
            <span className="text-[#3b82f6] font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Product Studio</span>
            <h2 className="text-5xl font-black text-white tracking-tight uppercase font-montserrat">Featured Projects</h2>
          </div>
          <Link to="/portfolio" className="hidden sm:flex items-center text-[#94a3b8] hover:text-[#3b82f6] transition-colors font-bold uppercase tracking-widest text-sm">
            See all products <SafeIcon icon={FiArrowRight} className="ml-2" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <motion.a
              key={index}
              href={product.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group bg-[#2a3658] border border-[#344271] p-8 rounded-[32px] hover:bg-[#344271] hover:border-[#3b82f6]/40 transition-all duration-300 flex flex-col backdrop-blur-sm shadow-2xl relative overflow-hidden"
            >
              <div className="absolute top-6 right-6 z-10">
                <SafeIcon icon={FiExternalLink} className="text-white/20 group-hover:text-[#3b82f6] transition-colors w-5 h-5" />
              </div>

              <div className="flex flex-col h-full">
                <div className="w-24 h-24 bg-white rounded-2xl flex items-center justify-center p-3 border border-[#344271] group-hover:border-[#3b82f6]/30 overflow-hidden transition-all shadow-inner mb-8">
                  <img 
                    src={product.icon} 
                    alt={product.title} 
                    className="w-full h-full object-contain transition-transform group-hover:scale-110" 
                    referrerPolicy="no-referrer"
                  />
                </div>
                
                <h3 className="text-2xl font-black text-white mb-3 tracking-tight uppercase font-montserrat">{product.title}</h3>
                <p className="text-[#e2e8f0] leading-relaxed text-lg font-medium opacity-90">{product.description}</p>
              </div>
            </motion.a>
          ))}
        </div>

        <div className="mt-12 sm:hidden text-center">
          <Link to="/portfolio" className="inline-flex items-center text-[#94a3b8] hover:text-[#3b82f6] transition-colors font-bold uppercase tracking-widest text-sm">
            See all products <SafeIcon icon={FiArrowRight} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;